<!--
 * @Author: pangshuting 2723947616@qq.com
 * @Date: 2022-05-26 17:45:48
 * @LastEditors: pangshuting 2727947616@qq.com
 * @LastEditTime: 2022-08-16 10:58:12
 * @FilePath: \official-web\src\components\phoneFooter.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="footer-wrapper">
    <div class="log-div">
      <img class="logImg" :src="require('@/assets/images/Type_Badge_Properties_White.png')" />
    </div>

    <div class="title">联系我们</div>

    <div class="contract">
      <div class="icon-box" @click="iconClick(1)">
        <i class="icon-item icon-gwweixin"></i>
        <img class="icon-img" :src="require('@/assets/images/公众号@2x.png')" v-show="showWxQR[1]" />
      </div>
      <div class="icon-box" @click="iconClick(2)">
        <i class="icon-item icon-gwxiaochengxu"></i>
        <img class="icon-img" :src="require('@/assets/images/小程序@2x.png')" v-show="showWxQR[2]" />
      </div>
      <div class="icon-box" @click="iconClick(3)">
        <img class="icon-item-img" :src="require('@/assets/images/lrb_icon@2x.png')" />
        <img class="icon-img" :src="require('@/assets/images/小红书@2x.png')" v-show="showWxQR[3]" />
      </div>
      <div class="icon-box" @click="iconClick(4)">
        <i class="icon-item icon-gwdouyin"></i>
        <img class="icon-img" :src="require('@/assets/images/抖音@2x.png')" v-show="showWxQR[4]" />
      </div>
      <div class="icon-box" @click="iconClick(5)">
        <i class="icon-item icon-gwxinlangweibo"></i>
      </div>
    </div>

    <div class="clause">
      <div @click="toUseTerms">
        使用条款
      </div>
      <div @click="toProductDetail">信息披露</div>
    </div>
    <div class="icp">
      <span style="color: #999">版权归特百惠（中国）有限公司所有，未经许可不得转载或链接&nbsp;<a href="https://beian.miit.gov.cn/"
          style="color: #999">&nbsp;粤ICP备09130465号</a></span>
    </div>
  </div>
</template>
<script>
import { buryPoint } from '@/util/utils'
export default {
  data() {
    return {
      showWxQR: {
        1: false,
        2: false,
        3: false,
        4: false,
      },
    }
  },
  methods: {
    toProductDetail() {
      buryPoint('Button_Click', { button_name: '信息披露' })
      this.$router.push({
        path: `/mobile/infoDisclosurePhone`
      })
    },
    toUseTerms() {
      buryPoint('Button_Click', { button_name: '使用条款' })
      this.$router.push({
        path: `/mobile/useTerms`
      })
    },
    toWX() {
      this.showWxQR = !this.showWxQR
    },
    iconClick(type) {
      if (type != 5) {
        Object.keys(this.showWxQR).forEach(item => {
          if (item == type) {
            this.showWxQR[item] = !this.showWxQR[item]
          } else {
            this.showWxQR[item] = false
          }
        })
      } else {
        window.open('https://weibo.com/tupperwareyes')
      }
    }
  },
  created() { }
}
</script>

<style lang="scss" scoped>
.footer-wrapper {
  min-height: 135px;
  min-width: 100%;
  background-color: #000;
  color: #fff;
  padding: 30px 0;

  .log-div {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    .logImg {
      width: 140px;
      height: 140px;
    }
  }


  .title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-bottom: 14px;
    display: flex;
    justify-content: center;
  }

  .contract {
    display: flex;
    justify-content: center;

    .icon-box {
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .icon-item {
        font-size: 24px;
      }

      .icon-img {
        position: absolute;
        width: 225px;
        height: 300px;
        top: -300px;

      }

      .icon-item-img {
        width: 50%;
      }
    }
  }

  .icp {
    justify-content: center;
    display: flex;
    margin-bottom: 30px;
    margin-top: 18px;

    img {
      width: 20px;
      height: 20px;
      align-self: center;
    }

    span {
      font-size: 10px;
      align-self: center;
      color: #999999;
      white-space: nowrap;
      transform: scale(0.75);
    }
  }
}

.clause {
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    font-size: 11px;
    margin-top: 20px;
    text-align: center;
    color: #666666;
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/phoneFooter.vue